<h4 class="m-3">Subscription #{{subscriptionId | async}}</h4>
<hr/>
<div style="background: #eee;" class="p-3">
  <app-patient-subscriptions-form 
    [editable]="false"
    [subscriptionDataId]="subscriptionId | async" 
    [patientGuid]="patientGuid | async"
  ></app-patient-subscriptions-form>
</div>